export default "__VITE_ASSET__BCG5LI1Z__"